import { render } from "./ServiceWorkerUpdate.vue?vue&type=template&id=218f1600&scoped=true"
import script from "./ServiceWorkerUpdate.vue?vue&type=script&lang=js"
export * from "./ServiceWorkerUpdate.vue?vue&type=script&lang=js"

import "./ServiceWorkerUpdate.vue?vue&type=style&index=0&id=218f1600&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218f1600"]])

export default __exports__